module.exports = __webpack_public_path__ + "static/media/f3.cebf1b6e.jpeg";